export default {
  "Sourcing": "Fresh catch sourced from small scale fishermen",
  "Processing": "Hygienically processed and packed",
  "Dispatching": "In secure containers with optimum temperature monitored",
  "Dispatch": "In secure containers with optimum temperature monitored",
  "Home": "Traceable Seafood Experience at home!"
}